import { render } from "./AnalyprofitPrsonal.vue?vue&type=template&id=fb04d810&scoped=true&ts=true"
import script from "./AnalyprofitPrsonal.vue?vue&type=script&lang=ts"
export * from "./AnalyprofitPrsonal.vue?vue&type=script&lang=ts"

import "./AnalyprofitPrsonal.vue?vue&type=style&index=0&id=fb04d810&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb04d810"]])

export default __exports__